import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { TYPOGRAPHY_21_500, TYPOGRAPHY_27_500 } from 'theme/theme'

const Title = styled.h3`
  ${props => props.lg ? TYPOGRAPHY_27_500 : TYPOGRAPHY_21_500}

  position: relative;
  color: #646770;
  margin: 0;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
`

const Rectangle = styled.div`
  position: relative;
  display: flex;
  min-width: 35px;
  width: 50%;
  height: 3px;
  background: #e4af27;
  margin-top: 6px;

  @media (max-width: 525px) {
    width: 50px;
    margin-left: auto;
    margin-right: auto;
  }
`

export default function ModalSuperTitle ({ showRec, children, lg, Btn }) {
  return Btn
    ? (
    <div className="flex">
      <Title lg={lg}>
        { children }
        { showRec && <Rectangle /> }
      </Title>
      { Btn }
    </div>
      )
    : (
        <Title lg={lg}>
          { children }
          { showRec && <Rectangle /> }
        </Title>
      )
}

ModalSuperTitle.propTypes = {
  showRec: PropTypes.bool,
  Btn: PropTypes.any,
  children: PropTypes.any,
  lg: PropTypes.bool
}
